
























































import { Component, Vue } from 'vue-property-decorator';
import OrderWidgetBox from './OrderWidgetBox.vue';
import { LandingPageItem, OrderWidgetConfigurationItem } from '../../../store/landingpage/types';
import LoadingAnimation from '../../helper/LoadingAnimation.vue';
import { TrackingEventTypes } from '../../../plugins/tracking/types/tracking';
import { ApiEndpointEnum, defaultRequestConfig, getApiRequestConfig } from '../../../config/network';
import Axios, { AxiosResponse } from 'axios';
import { CloudUnitTypeName } from '../../../store/product/types';

@Component({
  components: { LoadingAnimation, OrderWidgetBox },
})
export default class OrderWidget extends Vue {
  landingPage: LandingPageItem = null;

  orderWidget: OrderWidgetConfigurationItem[] = null;

  loadingError = false;

  readonly axios = Axios.create(defaultRequestConfig);

  name = 'OrderWidget';

  get orderUrl(): string {
    return this.$api.data.pageData === undefined
      ? this.landingPage.orderUrl
      : (this.$api.data.pageData as LandingPageItem).orderUrl;
  }

  /**
   * event triggered when someone clicks on the create your own configuration url
   * @param event
   */
  onCustomOrderWidgetClick(event: Event): void {
    window.location.assign(this.orderUrl);
  }

  orderTracking(): void {
    this.$tracking.track({
      event: TrackingEventTypes.LP_SLOTBOX_BTN_ORDER_NOW,
      data: {
        type: 'button',
        target: this.orderUrl,
        productKey: this.landingPage ? this.landingPage.key : null,
        configuration: {
          slots: null,
          duration: null,
        },
      },
    });
  }

  /**
   * returns a mock widget data only for the preview
   * which is visible for a short time (loading state)
   */
  get mockWidget(): OrderWidgetConfigurationItem {
    return {
      units: 10,
      duration: 30,
      highlighted: false,
      locations: [
        {
          available: true,
          city: 'Gotham City',
          country: 'Marvel',
          countryCode: 'MV',
          product: {
            id: 0,
            server: {
              categoryId: 0,
              id: 0,
            },
          },
          formattedPrice: '0.00',
          orderUrl: '/',
          key: 'GHC',
          switchRegion: true,
          default: false,
        },
      ],
      cloudUnitType: {
        loco_key: 'general:non_special_texts:slot_plural',
        name: CloudUnitTypeName.SLOT,
        multiplier: 1,
      },
    };
  }

  fetchLandingPage(): Promise<LandingPageItem> {
    return new Promise((resolve, reject) => {
      this.axios.get(window.location.href.concat('.json'), defaultRequestConfig)
        .then((response: AxiosResponse<LandingPageItem>) => {
          const payload: LandingPageItem = response && response.data;
          resolve(payload);
        }, (error) => {
          reject(error);
        });
    });
  }

  fetchOrderWidgetConfiguration(
    { key }: LandingPageItem,
  ): Promise<Array<OrderWidgetConfigurationItem>> {
    return new Promise((resolve, reject) => {
      this.axios.get(
        `orderConfigurations?pageKey=${key}`,
        getApiRequestConfig(ApiEndpointEnum.ConfigurationAPI),
      ).then((response: AxiosResponse) => {
        const payload: Array<OrderWidgetConfigurationItem> = response && response.data;
        resolve(payload);
      }, (error) => {
        reject(error);
      });
    });
  }

  async mounted() {
    try {
      const landingpageResponseItem = await this.fetchLandingPage();
      this.landingPage = landingpageResponseItem;

      this.orderWidget = await this.fetchOrderWidgetConfiguration(landingpageResponseItem);
      this.loadingError = false;
    } catch (error) {
      // TODO: error handling when price configurations cannot be loaded
      this.loadingError = true;
    }
  }
}
